import React, { Component } from "react";
import LayoutWrapper from "./LayoutWrapper";
import AppTable from "../../partials/AppTable";
import ConfigureAssessmentParameterSearch from "./ConfigureAssessmentParameterSearch";
import ConfigureAssessmentParameterModal from "./ConfigureAssessmentParameterModal";
import ViewAssessmentParameterModal from "./ViewAssessmentParameterModal";
import NoOfParameterModal from "./NoOfParameterModal";
import { toast } from "react-toastify";

export class ConfigureAssessmentParameter extends Component {
  constructor(props) {
    super(props);
    props.initialconstruct && props.initialconstruct.bind(this)("ConfigureAssessmentParameter");
    this.addModalRef = React.createRef();
    this.noOfParamModalRef = React.createRef();

    this.state = {
      tableData: [],
      rowcount: 0,
      loader: false,
      columns: [
        {
          dataIndex: "parameter_id",
          title: "Parameter ID",
        },
        {
          dataIndex: "school_name",
          title: "School Name",
        },
        {
          dataIndex: "academic_year",
          title: "Academic Year",
        },
        {
          dataIndex: "no_of_parameter",
          title: "No. Of Parameter",
          render: (text, record) => (
            <span
              style={{ color: "#f39c12", textDecoration: "underline", cursor: "pointer" }}
              data-bs-toggle="modal"
              data-bs-target="#no_of_param_modal"
              onClick={() => this.viewParametersList(record)}
            >
              {text}
            </span>
          ),
        },
        {
          dataIndex: "created_on",
          title: "Created On",
        },
      ],
      search: {
        page: 1,
        limit: 10
      },
      editData: {},
      viewMode: false,
      editMode: false,
      activeParametersList: [],
      schoolOptions: [],
      academicYearOptions: [],
      categoryOptions: [],
      categoryList: [],
    };
  }

  componentDidMount() {
    this.fetchList();
    this.getSchoolNames();
    this.getAcademicYears();
    this.getAssessmentCategories();
  }

  getAssessmentCategories = () => {
    if (this.props.api && this.props.api.apiGetMasterCategory) {
      this.props.api
        .apiGetMasterCategory()
        .then((res) => {
          let list = res?.data || res || [];
          if (!Array.isArray(list) && res?.data?.records) list = res.data.records;
          let categoryOptions = (res?.data?.options && res.data.options("_id", "name")) || [];
          if (!categoryOptions || categoryOptions.length === 0) {
            categoryOptions = (Array.isArray(list) ? list : []).map(item => ({
              key: item._id,
              value: item.name || item.category_name || item.title || item._id,
            }));
          }
          this.setState({ categoryOptions, categoryList: Array.isArray(list) ? list : [] });
        })
        .catch((err) => {
          console.error("Failed to fetch assessment categories", err);
        });
    }
  };

  getSchoolNames = () => {
    const api = this.props.api || this.api || window.app?.api;
    if (!api) return;

    let currentAdminRole = localStorage.getItem("currentAdminRole");
    let fetchPromise;

    if (currentAdminRole === "SCHOOL_COORDINATOR" && api.apiGetAllSchoolListForCoordinator) {
      fetchPromise = api.apiGetAllSchoolListForCoordinator();
    } else if (api.apiGetSchoolList) {
      fetchPromise = api.apiGetSchoolList();
    } else if (api.apiGetAllSchoolListSuperAdmin) {
      fetchPromise = api.apiGetAllSchoolListSuperAdmin();
    }

    if (fetchPromise) {
      fetchPromise
        .then((res) => {
          let schools = [];
          if (res && res.data && Array.isArray(res.data) && res.data[0] && res.data[0].records) {
            schools = res.data[0].records;
          } else if (res && res.data && res.data.records) {
            schools = res.data.records;
          } else if (res && Array.isArray(res.data)) {
            schools = res.data;
          } else if (Array.isArray(res)) {
            schools = res;
          }

          let schoolOptions = schools.map((s) => ({
            label: s.school_name,
            key: s.school_id,
            value: s.school_id,
            ...s,
          }));

          this.setState({ schoolOptions });
        })
        .catch((err) => console.error("Failed to load school options", err));
    }
  };

  getAcademicYears = () => {
    if (this.props.api && this.props.api.apiGetAcademicYears) {
      this.props.api
        .apiGetAcademicYears()
        .then(({ data }) => {
          this.setState({
            academicYearOptions: data?.options("_id", "display_value") || [],
          });
        })
        .catch(() => { });
    }
  };

  fetchList(data) {
    this.setState({ loader: true });
    let payload = {
      ...this.state.search,
      ...data,
    };

    // Remove empty strings or undefined values so they aren't sent in the query params
    payload = Object.filter(payload, (val) => val);

    if (localStorage.getItem("currentAdminRole") === "SCHOOL_ADMIN") {
      payload.school_id = localStorage.getItem("school_admin_id");
    }
    this.props.api
      .apiGetOfflineAssessments(payload)
      .then(({ data, total }) => {
        this.setState({
          tableData: [...data],
          rowcount: total,
          loader: false,
        });
        if (this.searchRef?.updateParametersFromRecords) {
          this.searchRef.updateParametersFromRecords(data);
        }
      })
      .catch((err) => {
        console.error(err);
        this.setState({ loader: false });
      });
  }

  onPageChange(pageData) {
    this.setState(
      {
        search: {
          ...this.state.search,
          page: pageData.current,
          limit: pageData.pageSize || pageData.defaultPageSize || 10,
        },
      },
      () => this.fetchList()
    );
  }

  onSearch(data) {
    this.setState({
      search: {
        ...this.state.search,
        ...data,
        page: 1,
      }
    }, () => {
      this.fetchList();
    });
  }

  openAddModal = () => {
    this.setState({ editMode: false, viewMode: false, editData: null });
  };

  editAction = (v) => {
    if (!v) return;
    this.setState({ loader: true });
    try {
      this.props.api.apiGetOfflineAssessmentById({ assessment_id: v.assessment_id || v._id })
        .then((res) => {
          const data = res.data;
          let schoolVal = [];
          if (data.school_id) {
            schoolVal = Array.isArray(data.school_id) ? data.school_id : [data.school_id];
          } else if (data.school?.school_id) {
            schoolVal = [data.school.school_id];
          } else if (data.school?._id) {
            schoolVal = [data.school._id];
          } else if (v.school_id) {
            schoolVal = Array.isArray(v.school_id) ? v.school_id : [v.school_id];
          }

          const mappedData = {
            ...data,
            academic_year: data.academic_year_id?._id || data.academic_year_id || "",
            school_name: schoolVal,
            school_id: schoolVal[0] || data.school_id || "",
            parameters: data.parameters && data.parameters.length > 0 ? data.parameters.map(p => ({
              name: p.name || "",
              max_marks: p.maxMark !== undefined ? p.maxMark : (p.max_marks || ""),
              category_id: p.category_id?._id || p.category_id || ""
            })) : [{ name: "", max_marks: "", category_id: "" }]
          };
          this.setState({
            editMode: true,
            viewMode: false,
            editData: mappedData,
            loader: false,
          }, () => {
            document.querySelector("#config_assess_param_modal_trigger")?.click();
          });
        })
        .catch((err) => {
          console.error("Failed to fetch assessment by ID", err);
          this.setState({ loader: false });
          window.error("Failed to fetch assessment details");
        });
    } catch (err) {
      console.error("Synchronous error calling API:", err);
      this.setState({ loader: false });
      window.error("An error occurred while fetching details.");
    }
  };

  viewAction = (v) => {
    if (!v) return;
    this.setState({ loader: true });
    try {
      const assessment_id = v.assessment_id || v._id;
      console.log("assessment_id", assessment_id);
      this.props.api.apiGetOfflineAssessmentById({ assessment_id })
        .then((res) => {
          const data = res.data;
          let schoolVal = [];
          if (data.school_id) {
            schoolVal = Array.isArray(data.school_id) ? data.school_id : [data.school_id];
          } else if (data.school?.school_id) {
            schoolVal = [data.school.school_id];
          } else if (data.school?._id) {
            schoolVal = [data.school._id];
          } else if (v.school_id) {
            schoolVal = Array.isArray(v.school_id) ? v.school_id : [v.school_id];
          }

          const mappedData = {
            ...data,
            academic_year: data.academic_year_id?._id || data.academic_year_id || "",
            school_name: schoolVal,
            school_id: schoolVal[0] || data.school_id || "",
            parameters: data.parameters && data.parameters.length > 0 ? data.parameters.map(p => ({
              name: p.name || "",
              max_marks: p.maxMark !== undefined ? p.maxMark : (p.max_marks || ""),
              category_id: p.category_id?._id || p.category_id || ""
            })) : [{ name: "", max_marks: "", category_id: "" }]
          };
          this.setState({
            editMode: false,
            viewMode: true,
            editData: mappedData,
            loader: false,
          }, () => {
            document.querySelector("#view_assess_param_modal_trigger")?.click();
          });
        })
        .catch((err) => {
          console.error("Failed to fetch assessment by ID", err);
          this.setState({ loader: false });
          window.error("Failed to fetch assessment details");
        });
    } catch (err) {
      console.error("Synchronous error calling API:", err);
      this.setState({ loader: false });
      window.error("An error occurred while fetching details.");
    }
  };

  deleteAction = (v) => {
    window.confirm("Do you really want to delete this assessment?").promise.then(() => {
      this.setState({ loader: true });
      this.props.api.apiDeleteOfflineAssessmentById({ 
        assessment_id: v.assessment_id || v._id,
        school_id: v.school_id || (typeof v.school === "object" ? v.school?.school_id || v.school?._id : v.school)
      })
        .then(() => {
          this.setState({ loader: false });
          window.success("Assessment deleted successfully!");
          this.fetchList();
          this.getAssessmentCategories();
          this.searchRef?.getParameters && this.searchRef.getParameters();
          this.searchRef?.getSchoolNames && this.searchRef.getSchoolNames();
          this.searchRef?.getAcademicYears && this.searchRef.getAcademicYears();
        })
        .catch((err) => {
          console.error(err);
          this.setState({ loader: false });
          let errorMsg = err?.response?.data?.message || err?.response?.data?.issues?.message || "Failed to delete assessment";
          if (err?.response?.data?.issues?.code === "ASSESSMENT_IS_IN_PROGRESS_CAN_NOT_DELETE") {
            errorMsg = "Assessment is in progress and cannot be deleted.";
          }
          window.error(errorMsg);
        });
    });
  };

  viewParametersList = (record) => {
    let params = record.parameters ? record.parameters.map(p => {
      let catId = p.category_id?._id || p.category_id;
      let categoryObj = this.state.categoryList.find(c => c._id === catId);
      return {
        ...p,
        category_name: categoryObj ? (categoryObj.name || categoryObj.category_name) : (p.category_id?.name || "")
      };
    }) : [];
    this.setState({
      activeParametersList: params
    });
  };

  handleModalSubmit = (e, data) => {
    e.preventDefault();
    console.log("Submit data", data);

    let schoolIds = [];
    if (Array.isArray(data.school_name)) {
      schoolIds = data.school_name.filter(Boolean);
    } else if (data.school_name) {
      schoolIds = [data.school_name];
    }

    if (!this.state.editMode && schoolIds.length === 0) {
      window.error("Please select a school.");
      return;
    }
    if (!data.academic_year) {
      window.error("Please select an academic year.");
      return;
    }
    if (!data.parameters || data.parameters.length === 0) {
      window.error("Please add at least one parameter.");
      return;
    }
    for (let i = 0; i < data.parameters.length; i++) {
      let p = data.parameters[i];
      if (!p.name || !p.name.trim()) {
        window.error(`Please enter a valid name for Parameter ${i + 1}`);
        return;
      }
      if (!p.category_id) {
        window.error(`Please select an Assessment Category for Parameter ${i + 1}`);
        return;
      }
      if (!p.max_marks || isNaN(p.max_marks) || Number(p.max_marks) <= 0) {
        window.error(`Please enter valid max marks for Parameter ${i + 1}`);
        return;
      }
    }

    let payload = {
      school_id: schoolIds,
      academic_year_id: data.academic_year,
      parameters: data.parameters.map(p => ({
        name: p.name.trim(),
        maxMark: parseInt(p.max_marks, 10) || 0,
        category_id: p.category_id
      }))
    };

    this.setState({ loader: true });

    try {
      let apiPromise;
      if (this.state.editMode && this.state.editData && (this.state.editData.assessment_id || this.state.editData._id)) {
        const schoolIdParam = schoolIds[0] || (typeof this.state.editData.school_id === "string" ? this.state.editData.school_id : "") || this.state.editData.school?.school_id || this.state.editData.school?._id || "";
        
        let editPayload = {
          academic_year_id: data.academic_year,
          parameters: data.parameters.map(p => ({
            name: p.name.trim(),
            maxMark: parseInt(p.max_marks, 10) || 0,
            category_id: p.category_id
          }))
        };

        apiPromise = this.props.api.apiUpdateOfflineAssessmentById(
          editPayload,
          { 
            assessment_id: this.state.editData.assessment_id || this.state.editData._id,
            school_id: schoolIdParam
          }
        );
      } else {
        apiPromise = this.props.api.apiCreateOfflineAssessment(payload);
      }

      apiPromise
        .then(() => {
          this.setState({ loader: false });
          this.closeModal();
          document.querySelector("#config_assess_param_modal #bsmodalclose")?.click();
          this.fetchList();
          this.getAssessmentCategories();
          if (this.searchRef?.updateParametersFromRecords && data.parameters) {
            this.searchRef.updateParametersFromRecords([{ parameters: data.parameters }]);
          }
          this.searchRef?.getParameters && this.searchRef.getParameters();
          this.searchRef?.getSchoolNames && this.searchRef.getSchoolNames();
          this.searchRef?.getAcademicYears && this.searchRef.getAcademicYears();
          window.success(`Assessment ${this.state.editMode ? 'updated' : 'created'} successfully!`);
        })
        .catch((err) => {
          console.error(err);
          this.setState({ loader: false });
          const issuesCode = err?.response?.data?.issues?.code || err?.data?.issues?.code || err?.issues?.code;
          let errorMsg = err?.response?.data?.message || err?.data?.message || err?.response?.data?.issues?.message || err?.message || "Operation failed";

          if (issuesCode === "SOME_SCHOOL_ASSESSMENT_ALREADY_PRESENT") {
            errorMsg = "Assessment already present for some schools";
          } else if (issuesCode === "ASSESSMENT_ALREADY_PRESENT") {
            errorMsg = "Assessment already present for this school";
          } else if (issuesCode === "ASSESSMENT_IS_IN_PROGRESS_CAN_NOT_EDIT") {
            errorMsg = "Assessment is in progress and cannot be edited.";
          }
          window.error(errorMsg);
        });
    } catch (err) {
      console.error("Synchronous error calling API:", err);
      this.setState({ loader: false });
      window.error("An error occurred during submission.");
    }
  };

  closeModal = () => {
    this.setState({
      editData: {},
      editMode: false,
      viewMode: false,
    });
    // Ensure both modals are closed
    document.querySelector("#config_assess_param_modal #bsmodalclose")?.click();
    document.querySelector("#view_assess_param_modal #bsmodalclose")?.click();
  };

  render() {
    let { tableData, columns, editData, editMode, viewMode, activeParametersList, rowcount, loader } = this.state;
    return (
      <LayoutWrapper title="Configure Assessment Parameter" back="">
        {loader && (
          <div className="loader-container">
            <div className="spinner"></div>
          </div>
        )}
        <div className="row mb-4">
          <div className="col-12 text-end">
            <button
              className="btn add-btn"
              data-bs-toggle="modal"
              data-bs-target="#config_assess_param_modal"
              onClick={this.openAddModal}
            >
              <i className="fa fa-plus m-r-5"></i> Add New
            </button>
            <button
              id="config_assess_param_modal_trigger"
              data-bs-toggle="modal"
              data-bs-target="#config_assess_param_modal"
              style={{ display: "none" }}
            ></button>
            <button
              id="view_assess_param_modal_trigger"
              data-bs-toggle="modal"
              data-bs-target="#view_assess_param_modal"
              style={{ display: "none" }}
            ></button>
          </div>
        </div>

        {/* Search Filter Section */}
        <ConfigureAssessmentParameterSearch
          ref={(r) => (this.searchRef = r)}
          api={this.props.api || this.api}
          schoolOptions={this.state.schoolOptions}
          onSearch={(data) => this.onSearch(data)}
        />

        <div className="row">
          <div className="col-12">
            {!!tableData.length && (
              <AppTable
                data={tableData}
                columns={columns}
                total={rowcount}
                onChange={(...arg) => this.onPageChange(...arg)}
                isCustomRowKey={true}
                customRowKey="assessment_id"
                viewable={true}
                editable={true}
                deletable={true}
                targetType="tap"
                editAction={(v) => this.editAction(v)}
                viewAction={(v) => this.viewAction(v)}
                deleteAction={(v) => this.deleteAction(v)}
                isresponsive={true}
                reorder={true}
              />
            )}
            {tableData.length === 0 && <div className="empty_layout_configureassessments"></div>}
          </div>
        </div>

        <ConfigureAssessmentParameterModal
          id="config_assess_param_modal"
          title={`${editMode ? "Edit Assessment Parameter" : "Add Assessment Parameter"}`}
          submitText={`${editMode ? "Update" : "Save"}`}
          editdata={editData}
          editMode={editMode}
          viewMode={false}
          submitButton={true}
          closeButton={true}
          schoolOptions={this.state.schoolOptions}
          academicYearOptions={this.state.academicYearOptions}
          categoryOptions={this.state.categoryOptions}
          onSubmit={this.handleModalSubmit}
          onClose={this.closeModal}
        />

        <ViewAssessmentParameterModal
          id="view_assess_param_modal"
          title="View Assessment Parameter"
          editdata={editData}
          viewMode={true}
          closeButton={true}
          schoolOptions={this.state.schoolOptions}
          academicYearOptions={this.state.academicYearOptions}
          categoryOptions={this.state.categoryOptions}
          onClose={this.closeModal}
        />

        <NoOfParameterModal
          id="no_of_param_modal"
          parameters={activeParametersList}
          onClose={() => this.setState({ activeParametersList: [] })}
        />
      </LayoutWrapper>
    );
  }
}

export default connect(ConfigureAssessmentParameter);
